module.exports = __webpack_public_path__ + "static/media/residentialIcon.b9ee0dfa.svg";